import { ElectronScreenShareMedia } from './electron-display-media-opts';

export enum ElectronBusEvents {
  ReceiveScreenShareSources = 'ReceiveScreenShareSources',
}

export type ElectronBusEventPayloads = {
  [ElectronBusEvents.ReceiveScreenShareSources]: ElectronScreenShareMedia[];
};
